import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { IPageState } from "@rhc-shared-components/table-toolbar/dist/models/GeneralModels";
import { getAttachedProductsById } from "../api/pyxis";
import { IAPIError } from "../interfaces/common";
import { IAttachableProducts } from "../interfaces/attachedProducts";
import { InitialPaginationValue } from "../constants/pagination";

export const attachedProductsQueryKey = ['attachedProductsToCert'] as const;

export const useAttachedProducts = (
  projectId: string | undefined,
  pagination: IPageState = InitialPaginationValue,
  enabled?: boolean
): UseQueryResult<IAttachableProducts, IAPIError> => {
  return useQuery<IAttachableProducts, IAPIError>({
    queryKey: [...attachedProductsQueryKey, projectId, pagination.page, pagination.perPage],
    queryFn: async ({ signal }) => {
      return await getAttachedProductsById(
        projectId,
        {
          page: pagination.page - 1,
          page_size: pagination.perPage
        },
        {},
        signal
      );
    },
    enabled
  });
};
